import React from 'react';
import Report from './containers/Report';

export default [
    {
        path: '/reports',
        exact: true,
        component: () => <Report />
    },
];